import {getFileNameAndExtension} from "../../../utils/common/getFileExtension";

const handlerExport = (api, handleModalAlert, setLoading) => {
    setLoading && setLoading(true)
    api().then((response) => {
        const filename = getFileNameAndExtension(response.headers['content-disposition']);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        handleModalAlert("Данные получены", 'success')
    })
        .catch((error) => {
            handleModalAlert(error)
        }).finally(() => setLoading && setLoading(false))
}
export {handlerExport}